import type { FormAnswerValueInput as GeneratedValueInput } from '@/types/schema';
import type { FormsAnswerReview_TreeFragment } from '../graphql/AnswerTree.generated';

/** Apollo sends variables as JSON, without its read-side Decimal conversion. */
export type FormAnswerValueInput = Omit<GeneratedValueInput, 'numberValue' | 'properties' | 'items'> & {
  numberValue?: string;
  properties?: {
    schemaNodeID: string;
    value: FormAnswerValueInput;
  }[];
  items?: {
    id: string | null;
    value: FormAnswerValueInput;
  }[];
};
type WireNode = FormsAnswerReview_TreeFragment['nodes'][number];
type WireAssessment = FormsAnswerReview_TreeFragment['assessments'][number];

/** Normalize optional GraphQL nulls and parsed decimals at the view-model boundary. */
export type FormAnswerTarget = {
  schemaNodeID: WireNode['target']['schemaNodeID'];
  arrayItemID: string | null;
};
export type FormAnswerNode = Omit<WireNode, 'target' | 'kind' | 'numberValue'> & {
  target: FormAnswerTarget;
  kind: `${WireNode['kind']}`;
  numberValue?: string | null;
};
export type FormNodeAssessment = Omit<WireAssessment, 'target' | 'status'> & {
  target: FormAnswerTarget;
  status: `${WireAssessment['status']}`;
};
export type FormAnswerTree = {
  __typename?: 'FormAnswerTree';
  nodes: FormAnswerNode[];
  assessments: FormNodeAssessment[];
};
export function normalizeAnswerTree(tree: FormsAnswerReview_TreeFragment): FormAnswerTree {
  return {
    ...tree,
    nodes: tree.nodes.map(node => ({
      ...node,
      target: {
        ...node.target,
        arrayItemID: node.target.arrayItemID ?? null
      },
      // toFixed() without a precision argument does not round or emit an exponent.
      numberValue: typeof node.numberValue === 'string' ? node.numberValue : node.numberValue?.toFixed() ?? null
    })),
    assessments: tree.assessments.map(assessment => ({
      ...assessment,
      target: {
        ...assessment.target,
        arrayItemID: assessment.target.arrayItemID ?? null
      }
    }))
  };
}